import { Injectable } from '@angular/core';
import { PlatformService } from '../platform.service';
@Injectable({ providedIn: 'root' })
export class ProviderCacheService {
  private readonly CACHE_PREFIX = 'provider_';
   private readonly TTL = 30 * 24 * 60 * 60 * 1000; // 1 month in milliseconds
  constructor(
    private platform: PlatformService,
  ) {}
 
  set(providerId: string, data: unknown): void {
    if (!this.platform.isBrowserPlatform() || !providerId) {
      return;
    }

    const cacheKey = `${this.CACHE_PREFIX}${providerId}`;

    try {
      const item = {
        value: data,
        expiry: Date.now() + this.TTL
      };

      localStorage.setItem(cacheKey, JSON.stringify(item));
    } catch (error) {
      console.error('Failed to save provider cache:', error);
    }
  }

  get<T>(providerId: string): T | null {
    if (!this.platform.isBrowserPlatform() || !providerId) {
      return null;
    }

    const cacheKey = `${this.CACHE_PREFIX}${providerId}`;
    const itemStr = localStorage.getItem(cacheKey);

    if (!itemStr) {
      return null;
    }

    try {
      const item = JSON.parse(itemStr);
      // Validate structure
      if (!item.expiry || Date.now() > item.expiry) {
        localStorage.removeItem(cacheKey);
        return null;
      }

      return item.value as T;
    } catch (error) {
      console.error('Failed to read provider cache:', error);
      localStorage.removeItem(cacheKey); // remove corrupted entry
      return null;
    }
  }

  clearAllProviders(): void {
    if (!this.platform.isBrowserPlatform()) return;

    Object.keys(localStorage)
      .filter(key => key.startsWith(this.CACHE_PREFIX))
      .forEach(key => localStorage.removeItem(key));
  }
}
